import _ from '@lodash';
import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useSelector, useDispatch } from 'react-redux';
import TableFilterRepo from './TableFilterRepo';

function TableBrowserFiltersDialog(props) {
	const { t } = useTranslation(['tableBrowser', 'common']);
	const dispatch = useDispatch();
	const filterList = useSelector(rootState => rootState[props.config.key].tableBrowserFilter.filterList);
	const [changedFilterList, setChangedFilterList] = useState([]);

	useEffect(() => {
		setChangedFilterList(filterList || []);
	}, [filterList]);

	const handleFilterChange = useCallback((filterValue) => {
		setChangedFilterList((prev) => {
			const i = prev.findIndex(el => el.propertyName === filterValue.propertyName);
			if (i > -1) return prev.map(el => (el.propertyName === filterValue.propertyName ? filterValue : el));
			return [filterValue, ...prev];
		});
	}, []);

	const handleFilterRemove = useCallback((filterKey) => {
		setChangedFilterList((prev) => {
			const i = prev.findIndex(el => el.propertyName === filterKey);
			if (i > -1) return prev.filter(el => el.propertyName !== filterKey);
			return prev;
		});
	}, []);

	const handleFiltering = useCallback(() => {
		dispatch({ type: `${props.config.key}/filter/setFilterList`, payload: changedFilterList });
		props.onClose();
	}, [dispatch, props.config.key, props.onClose, changedFilterList]);

	const getSpecificFilterField = useCallback((config) => {
		if (_.isFunction(config.visibleIf) && !config.visibleIf()) return null;

		let tableFilterName = config.propertyType + config.type;
		if (typeof config.customField !== 'undefined') tableFilterName = config.customField;

		if (typeof TableFilterRepo[tableFilterName] !== 'undefined') {
			const SpecificFilterField = TableFilterRepo[tableFilterName];

			return (
				<SpecificFilterField
					config={props.config}
					filterConfig={config}
					onFilterChanged={(v) => handleFilterChange(v)}
					onFilterRemoved={(filterKey) => handleFilterRemove(filterKey)}
				/>
			);
		}

		return null;
	}, [props.config, handleFilterChange, handleFilterRemove]);

	const getFilterFieldKey = (f, idx) => {
		return String(f?.propertyName ?? f?.customField ?? (f?.propertyType + f?.type) ?? idx);
	};

	return (
		<Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="sm">
			<DialogTitle id="form-dialog-title">{t('FILTER_CONDITIONS')}</DialogTitle>
			<DialogContent>
				{props.filterFields.map((f, idx) => (
					<React.Fragment key={getFilterFieldKey(f, idx)}>
						{getSpecificFilterField(f)}
					</React.Fragment>
				))}
			</DialogContent>
			<DialogActions>
				<Button onClick={() => props.onClose()}>{t('common:CANCEL')}</Button>
				<Button onClick={() => handleFiltering()} color="primary">
					{t('FILTER')}
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default TableBrowserFiltersDialog;